import { Component, OnInit, EventEmitter, Output, ViewEncapsulation, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { Packagesponsor, Prospect } from 'src/app/entity/prospect';
import { Socifact } from 'src/app/entity/Facture';
import { ProspectService } from 'src/app/service/prospect.service';
import { PackagesponsorService } from 'src/app/service/package.service';
import { FactureService } from 'src/app/service/facture.service';
import { MenuItem } from 'primeng';
import { FormGroup } from '@angular/forms';
import { MailsService } from 'src/app/service/mails.service';
import { Contact } from 'src/app/entity/Contact';
import { ComposeMailComponent } from 'src/app/view/email/include/compose-mail/compose-mail.component';

@Component({
  selector: 'app-package-dialog',
  templateUrl: './package-dialog.component.html'  ,
 
encapsulation: ViewEncapsulation.None
})
export class PackageDialogComponent implements OnInit, OnDestroy  {
  tvaPercent:number=10;
  isModelMails;
  modelsCores;
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  display = false;
  selectedPackage: Packagesponsor;
  selectedProspect: Prospect;
  selectedSociFact: Prospect;

  articles:string;
  condition:string;
  @ViewChild(ComposeMailComponent)
  private composeMailComponent: ComposeMailComponent;
  socifacts: Socifact[];
  @Output() findPackage = new EventEmitter<Prospect>();
  items: MenuItem[];
  isSpeaker: boolean;
  activeIndex=0
  constructor(private prospectService: ProspectService, private packagesponsorService: PackagesponsorService, 
    private mailsService:MailsService,
    private factureService: FactureService) {
 
     }

  ngOnInit() {
    this.items = [
      {label: 'Payement'},
      {label: 'Contact'},
      {label: 'Package'},
      {label: 'Enregistrer'},
  ];
    this.factureService.getAllSociFact().subscribe((result) => {
      this.socifacts = result;
    });




  }
resetArticles(){
  if(  this.selectedPackage.isSpeaker)
{
  if(this.selectedPackage.isEnglish)
  this.mailsService.findodel(55).subscribe(result=>{
    this.selectedPackage.articles=result.corp;
  }
  
  );
  else{
    this.mailsService.findodel(56).subscribe(result=>{
      this.selectedPackage.articles=result.corp;
    }
    
    ); 
  }
}

  else
  {
    if(this.selectedPackage.isEnglish)
    this.mailsService.findodel(53).subscribe(result=>{
      this.selectedPackage.articles=result.corp;
    }  ) 
    else{
      this.mailsService.findodel(57).subscribe(result=>{
        this.selectedPackage.articles=result.corp;
      }
      
      ); 
    }
  }


}
resetConditions(){
  this.selectedPackage.conditions="Company Name:"+this.selectedPackage.companyName
  +" YES, I hereby confirm to proceed to the payment of 100% of cost this contract by bank transfer to EURL NAPEC"
  +" I agree to pay the 100% of the contract amount no later than April 15th 2020"
}



  
  save() {
    this.packagesponsorService.save(this.selectedPackage).subscribe(result => {
      this.findPackage.emit(this.selectedProspect);
      this.display = false;
    })

  }
  editPackage(prospect: Prospect) {
    this.selectedProspect = prospect;
    this.packagesponsorService.getByProspect(prospect.prospectId).subscribe(result => {
      this.selectedPackage = result;
      if (!this.selectedPackage) {
        this.selectedPackage = new Packagesponsor();
        this.selectedPackage.prospect = prospect;

        this.packagesponsorService.create(this.selectedPackage).subscribe(result1 => {
          this.packagesponsorService.getByProspect(prospect.prospectId).subscribe(packagesP => {
            this.selectedPackage = packagesP;
          });
        });

      }

      this.display = true;
    })


  }

  public CkeditorConfig = {

    language: 'fr',
    skin: 'office2013',
    cloudServices_tokenUrl: 'https://example.com/cs-token-endpoint',
    cloudServices_uploadUrl: 'https://your-organization-id.cke-cs.com/easyimage/upload/',
    uiColor: '#9AB8F3',
    toolbarCanCollapse: false,
    disableNativeSpellChecker: false,
    allowedContent: true,
    scayt_autoStartup: true,
    scayt_sLang: 'fr_FR',

    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',

 

    CKEDITOR: [{ dtd: { $removeEmpty: { i: 0 } } }],
    height: 400,

    toolbarGroups: [
      { name: 'spellchecker', groups: ['spellchecker'] },

      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph', 'forms', 'cleanup', 'mode'] },
      { name: 'editing', groups: ['find', 'selection'] },

      { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },

      { name: 'basicstyles', groups: ['basicstyles'] },






      { name: 'links', groups: ['links'] },
      { name: 'document', groups: ['document'] },

    ],
    removeButtons: 'NewPage  ,Textarea,Select,Button,ImageButton,HiddenField',
    protectedSource: [/{{[\s\S]*?}}/g],
    extraPlugins: 'sharedspace,easyimage,cloudservices'
    //CKEDITOR.dtd:[{$removeEmpty:{i: false}}]
    // CKEDITOR.dtd:false
    //.dtd.$removeEmpty['i'] = false

  }
  public CkeditorConfig2 = {

    language: 'fr',
    skin: 'office2013',
    cloudServices_tokenUrl: 'https://example.com/cs-token-endpoint',
    cloudServices_uploadUrl: 'https://your-organization-id.cke-cs.com/easyimage/upload/',
    uiColor: '#9AB8F3',
    toolbarCanCollapse: false,
    disableNativeSpellChecker: false,
    allowedContent: true,
    scayt_autoStartup: true,
    scayt_sLang: 'fr_FR',

    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',

 

    CKEDITOR: [{ dtd: { $removeEmpty: { i: 0 } } }],
    height: 400,

    toolbarGroups: [
      { name: 'spellchecker', groups: ['spellchecker'] },

      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph', 'forms', 'cleanup', 'mode'] },
      { name: 'editing', groups: ['find', 'selection'] },

      { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },

      { name: 'basicstyles', groups: ['basicstyles'] },






      { name: 'links', groups: ['links'] },
      { name: 'document', groups: ['document'] },

    ],
    removeButtons: 'NewPage  ,Textarea,Select,Button,ImageButton,HiddenField',
    protectedSource: [/{{[\s\S]*?}}/g],
    extraPlugins: 'sharedspace,easyimage,cloudservices'
    //CKEDITOR.dtd:[{$removeEmpty:{i: false}}]
    // CKEDITOR.dtd:false
    //.dtd.$removeEmpty['i'] = false

  }
  public CkeditorConfig3 = {
    allowedContent: true,
    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',
    CKEDITOR: [{dtd: {$removeEmpty: {i: 0} } } ],
    height: 400,
    toolbarGroups: [ ]
  }
  public CkeditorConfig3save= {

    language: 'fr',
    skin: 'office2013',
    cloudServices_tokenUrl: 'https://example.com/cs-token-endpoint',
    cloudServices_uploadUrl: 'https://your-organization-id.cke-cs.com/easyimage/upload/',
    uiColor: '#9AB8F3',
    toolbarCanCollapse: false,
    disableNativeSpellChecker: false,
    allowedContent: true,
    scayt_autoStartup: true,
    scayt_sLang: 'fr_FR',

    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',

 

    CKEDITOR: [{ dtd: { $removeEmpty: { i: 0 } } }],
    height: 400,

    toolbarGroups: [
      { name: 'spellchecker', groups: ['spellchecker'] },

      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph', 'forms', 'cleanup', 'mode'] },
      { name: 'editing', groups: ['find', 'selection'] },

      { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },

      { name: 'basicstyles', groups: ['basicstyles'] },






      { name: 'links', groups: ['links'] },
      { name: 'document', groups: ['document'] },

    ],
    removeButtons: 'NewPage  ,Textarea,Select,Button,ImageButton,HiddenField',
    protectedSource: [/{{[\s\S]*?}}/g],
    extraPlugins: 'sharedspace,easyimage,cloudservices'
    //CKEDITOR.dtd:[{$removeEmpty:{i: false}}]
    // CKEDITOR.dtd:false
    //.dtd.$removeEmpty['i'] = false

  }
  savePrint( isSpeaker:boolean) {
    this.packagesponsorService.save(this.selectedPackage).subscribe(result => {
      this.findPackage.emit(this.selectedProspect);
      this.print(isSpeaker )
      this.display = false;
    })
  }
  printPackage(prospect: Prospect,isSpeaker:boolean ) {
    this.selectedProspect = prospect;
    this.packagesponsorService.getByProspect(prospect.prospectId).subscribe(result => {
      this.selectedPackage = result;
      this.print(isSpeaker );
    });
  }
 
  calcTVA() { 
    const total = +this.selectedPackage.t1;
    if (this.selectedPackage.t1) {


      if (!isNaN(total)) {
        const tva =Math.round( total * (this.tvaPercent/100));
        const ttc = total + tva;
        
        this.selectedPackage.l2 = `VAT (${this.tvaPercent}%)`;
        this.selectedPackage.l3 = `Total`;

        this.selectedPackage.t2 = tva + '';
        this.selectedPackage.t3 = ttc + '';

      }
      else {
        alert('Le total doit étre numérique')
      }
    }
    else {
      alert('Veuillez spécifier le total')
    }
  }

  print(isSend:boolean ) {
    let uploadedFiles = []
    this.packagesponsorService.printContract(this.selectedPackage,isSend).subscribe(
      (res) => {
        var fileURL = URL.createObjectURL(res);
     if(!isSend)
        window.open(fileURL);
   
        res.name = "PackageSponsor.pdf"
        if(isSend){
          uploadedFiles.push(res);
          this.mailsService.findodel(6).subscribe(result => {
            this. composeMailComponent.prepareEmailModel(result,new Contact(), "NAPEC",new Prospect(), uploadedFiles)
          });
        }
      
  
      }
    );
  }


  hide(){
  this.display=false;
  this.selectedPackage=null;
   setTimeout(() => {
   // location.reload();
   }, 2000);
 
    
  }
  @HostListener('unloaded')
  ngOnDestroy() {
    //console.log('Items destroyed');
  }
}
 